<template>
  <div class="content">
    <arrorImg bg="white"></arrorImg>
    <navBar title="过期记录" color="#ffffff"></navBar>
    <div class="content-box" v-if="isEmpaty">
      <ul
        v-infinite-scroll="loadMore"
        :infinite-scroll-disabled="loading"
        infinite-scroll-distance="10"
      >
        <li class="list-item" :key="index" v-for="(item, index) in List">
          <div>
            <img src="../../../static/fenlei.png" alt="" /><span
              >{{ item.presentCurrency }} 书币</span
            >
          </div>
          <div>
            <img src="../../../static/overed.png" alt="" /><span
              >有效期至 {{ item.termOfValidity }}</span
            >
          </div>
        </li>
      </ul>
      <span class="no-more">{{ loadText }}</span>
    </div>
    <div class="no-log" v-else>
      <img src="../../../static/no-log.png" alt="" />
      <span>暂无记录~</span>
    </div>
  </div>
</template>
<script>
import { Toast, MessageBox } from "mint-ui";
import arrorImg from "../../components/arrow-img.vue";
import navBar from "../components/navbar.vue";
export default {
  components: {
    arrorImg,
    navBar,
  },
  data() {
    return {
      loading: false,
      isEmpaty: true,
      pageType: "",
      pageNo: 1,
      pageSize: 10,
      List: [],
      messageType: "", //消息类型
      clickMessId: 0, //消息ID
      channelRecordId: 0, //渠道号
      promotionCode: "", //推广链接
      isEntranceData: "",
      loadText: "加载中...",
      CountPage: 1,
    };
  },
  mounted() {
    this.pageType = this.$route.query.pageType;
    if (this.$route.query.isEntranceData) {
      this.isEntranceData = this.$route.query.isEntranceData;
    }
    if (this.$route.query.promotionCode) {
      this.promotionCode = this.$route.query.promotionCode;
    }
    if (this.$route.query.messageType) {
      this.clickMessId = this.$route.query.clickMessId;
      this.messageType = this.$route.query.messageType;
    }
    if (this.$route.query.channelRecordId) {
      this.channelRecordId = this.$route.query.channelRecordId;
    }
    var openid = this.$base.getStorage("openid");
    var isWxAuthorized = this.$base.getStorage("isWxAuthorized");
    var city = this.$base.getStorage("city");
    if (!openid) {
      //静默登录手动登录
      // this.wechatLogin();
    } else if (
      isWxAuthorized == 0 &&
      city == 1 &&
      openid &&
      !this.$store.state.user.isSNS
    ) {
      this.$base.setStorage("isSNS", true);
      this.$store.state.user.isSNS = true;
      this.$commonApi.snsapiUserinfo();
      this.insertPageAccessData();
      this.presentCurrencyList();
    } else {
      this.insertPageAccessData();
      this.presentCurrencyList();
    }
    this.$commonApi.share();
  },
  methods: {
    loadMore() {
      this.loading = true;
      if (this.CountPage > this.pageNo) {
        this.pageNo += 1;
        this.presentCurrencyList();
      } else {
        this.loading = false;
        this.loadText = "没有更多了";
      }
    },
    insertPageAccessData() {
      var prevPage = "";
      if (this.pageType === "bookCurrency") {
        prevPage = "书币";
      }else if (this.pageType === "bookCharge") {
        prevPage = "充值中心";
      } else if (this.pageType === "bookCity") {
        prevPage = "书城";
      } 
      var params = {
        pageName: "过期记录",
        pageRemark: "上级页面：" + prevPage,
        isEntranceData: this.isEntranceData,
      };
      this.$api.insertPageAccessData(params).then((res) => {});
    },
    wechatLogin() {
      var code = this.$base.GetUrlParam("code");
      if (!code) {
        console.log(window.location.href);
        // snsapi_base//静默   snsapi_userinfo手动
        let uri = encodeURIComponent(window.location.href);
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
          this.$store.state.user.appid +
          "&redirect_uri=" +
          uri +
          "&response_type=code&scope=snsapi_base&state=state&wechat_redirect&connect_redirect=1#wechat_redirect";
      } else {
        this.userRegister(code); //静默注册
      }
    },
    userRegister(code) {
      var params = {
        code: code,
      };
      this.$api.userRegister(params).then((res) => {
        if (res.status == 1) {
          this.$base.setStorage("openid", res.data.openid);
          if (res.data.isNewUser == 1) {
            //如果是新用户进行手动授权一次
            this.$router.push({
              path: "/pages/bookFrency/index",
              query: {
                pageType: "bookActivity",
              },
            });
          }
          this.insertPageAccessData();
          this.presentCurrencyList();
          var id = this.$base.getStorage("uid");
          if (!id) {
            this.$commonApi.getUserInfo(res.data.openid);
          }
        }
      });
    },
    presentCurrencyList() {
      var params = {
        isBeOverdue: 1,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      };
      this.$api.presentCurrencyList(params).then((res) => {
        if (res.status == 1) {
          this.CountPage = res.pages;
          if (this.pageNo <= this.CountPage) {
            if (this.pageNo == 1) {
              this.List = res.data;
              if (this.CountPage > 1) {
                this.loadText = "加载中...";
              } else {
                this.loadText = "没有更多了";
              }
            } else {
              this.List = this.List.concat(res.data);
            }
          } else {
            this.isEmpaty = false;
            this.loadText = "没有更多了";
          }
          console.log(this.loadText);
        }
      });
    },
  },
};
</script>

<style scoped>
.content {
  /* height:calc(48px + env(safe-area-inset-bottom)); */
  padding-bottom: constant(safe-area-inset-bottom);
  /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom);
  /* 兼容 iOS >= 11.2 */
  /* box-sizing: content-box; */
}
.no-log {
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.no-log img {
  width: 128px;
  height: 128px;
  display: block;
  margin: 0 auto;
}

.no-log span {
  display: block;
  font-size: 14px;
  color: #666666;
  margin-top: 20px;
}
.content-box {
  margin-top: calc(44px + env(safe-area-inset-top));
  padding-left: 16px;
  border-top: 1px solid #f3f3f3;
}
.list-item {
  display: flex;
  justify-content: space-between;
  padding: 12px 0px;
  padding-right: 16px;
  border-bottom: 1px solid #f3f3f3;
}
.list-item > div {
  display: flex;
}
.list-item > div:nth-of-type(1) > img {
  width: 16px;
  height: 16px;
  margin-top: 10px;
  margin-right: 8px;
}
.list-item > div:nth-of-type(2) > img {
  width: 48px;
  height: 36px;
  margin-right: 12px;
}
.list-item > div > span {
  color: #aaaaaa;
  line-height: 36px;
}
.list-item > div:nth-of-type(1) > span {
  font-size: 14px;
}
.list-item > div:nth-of-type(2) > span {
  font-size: 12px;
}
.no-more {
  display: block;
  text-align: center;
  font-size: 14px;
  color: #aaaaaa;
  margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/view/currencyOverdue/index.vue